/**
 * Русское склонение существительного по числу.
 *
 * Простое `n === 1 ? … : n < 5 ? … : …` даёт «21 заказов» и «11 заказа»: правило
 * зависит не от самого числа, а от его последних цифр, причём 11–14 — исключение.
 *
 * @example plural(21, ['заказ', 'заказа', 'заказов']) // 'заказ'
 * @example plural(11, ['заказ', 'заказа', 'заказов']) // 'заказов'
 */
export function plural(count: number, forms: [string, string, string]): string {
  const value = Math.abs(Math.trunc(count))
  const mod10 = value % 10
  const mod100 = value % 100

  if (mod10 === 1 && mod100 !== 11) return forms[0]
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return forms[1]
  return forms[2]
}

/** «заказ / заказа / заказов» — механики частоты заказов и корзина. */
export function pluralOrders(count: number): string {
  return plural(count, ['заказ', 'заказа', 'заказов'])
}
